export const money = value => {
	value = Math.round(value)
	return value
		? '$' +
		  value.toString().slice(0, value.toString().length - 2) +
		  '.' +
		  value.toString().slice(-2)
		: '$0'


}
